// utils/aggregateDistribution.js
//
// Згортає рядки з statistics_childrens_by_kindergarten
// ({_id: {age, sex, hasBenefit, disabilityType}, sum}) у підсумки за
// статтю/пільгою/труднощами. Спільна логіка для міського зведення
// (ChildrenTab.jsx) і деталізації одного садочка
// (ChildrenKindergartenDetail.jsx).
export const aggregateDistribution = (rows) => {
  const sex = { 'ч': 0, 'ж': 0 };
  const benefit = { yes: 0, no: 0 };
  const disability = {};
  let total = 0;

  (rows || []).forEach(r => {
    const { sex: s, hasBenefit, disabilityType } = r._id;
    const sum = r.sum;
    total += sum;
    sex[s] = (sex[s] || 0) + sum;
    if (hasBenefit) benefit.yes += sum; else benefit.no += sum;
    const dKey = disabilityType || 'none';
    disability[dKey] = (disability[dKey] || 0) + sum;
  });

  return { sexTotals: sex, benefitTotals: benefit, disabilityTotals: disability, total };
};
